export default "__VITE_ASSET__0IRDyljv__"